import React, { useState, useEffect, useRef } from 'react';
import ClassName from 'classnames';
import PageStore from '@/stores/page';
import doLog from '@/common/log';
import Item from './item';
import DetailIcon from '@/common/detail-icon';
import QuickStore from '@/stores/quick';
import DrawerStore from '@/stores/drawer';
import MyLazyComponent from '@/common/lazy-load';
interface AvailableActivity {
  activityId: number;
  endTime: number;
  hasLimit: boolean;
  limitCount: number;
  promotionContent: string;
  startTime: number;
  status: string;
}
interface ItemProps {
  data: SkuTypes.SkuAttr;
  index: number;
  skuAttr: SkuTypes.SkuAttr[];
  moq: number;
  moduleName: string;
  price: PriceTypes.Root;
  i18n: DetailTypes.i18n;
  sizeChartData?: IndustryTypes.sizeChartData;
  renderConfig: DetailTypes.renderConfig<{
    showType: string;
  }>;
  type: SkuTypes.TypeInfo;
  availableActivity: AvailableActivity;
}

const SKU_COVER_LAST_ITEMS_NUMBER = 3;
const SKU_LIST_MAX_LENGTH = 7;

export default function List(props: ItemProps) {
  // data是每一项sku的所有数据，skuAttr是所有sku的数据，index是第几个sku，type标识sku面板来自商品or样品or quickview
  const { data, skuAttr, index, type, i18n, renderConfig, sizeChartData, availableActivity } =
    props;

  // sku个数
  const skuItemsNumber = data.values.length;
  //每次透出的sku item个数
  const { showType } = renderConfig;
  const pageStore = PageStore((state) => state);
  const { secondScreen, isLoaded } = pageStore;
  const quickStore = QuickStore((state) => state);
  const { dialogShow } = DrawerStore((state) => state);
  const isLast = skuAttr.length === index + 1;
  const [lessMore, setLessMore] = useState(false);

  const selectInfo = data.values.filter((i) => i.selected === true);
  const SizeChart = MyLazyComponent(() => import('./size-chart'));

  // 只对quick 生效
  const renderSkuMore = () => {
    if (showType !== 'quick') return null;
    if (!isLast) return null;
    if (data.values.length > SKU_COVER_LAST_ITEMS_NUMBER) {
      return (
        <div className="show-more">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              doLog(
                lessMore ? '/sc.detail.sku_showmore' : '/sc.detail.sku_showless',
                `second=${secondScreen}&from=sku`,
              );
              setLessMore(!lessMore);
            }}
          >
            {lessMore ? i18n['pc-fantasy_show_less'] : i18n['product_detail_attributes_show_more']}
          </a>
          <DetailIcon className="detail-symbol" symbol={lessMore ? 'icon-up' : 'icon-down'} />
        </div>
      );
    }
    return null;
  };

  const getLimitNumber = () => {
    // 支持折叠
    if (lessMore) return data.values.length;
    if (showType === 'sku') {
      return SKU_LIST_MAX_LENGTH;
    }
    if (showType === 'quick' && isLast) {
      return SKU_COVER_LAST_ITEMS_NUMBER;
    }
    return data.values.length;
  };

  // 尺码表
  const renderSizeChart = () => {
    // Quick View 屏蔽
    if (quickStore.activeProductId) return null;
    if (showType === 'drawer' && data.levelFlag === 'size' && sizeChartData && isLoaded) {
      return <SizeChart data={sizeChartData} i18n={i18n} />;
    }
  };

  return (
    <>
      <h4>
        {/* sku每一项的title */}
        {index + 1}. {data.name}({skuItemsNumber})
        {!isLast && (
          <>
            : <span>{selectInfo[0]?.name}</span>
          </>
        )}
        {/* 如果sku的levelFlag为'size'，渲染尺码表 */}
        {renderSizeChart()}
      </h4>
      <div
        key={index}
        className={ClassName({
          'info-item': true,
          last: isLast && showType !== 'sku',
        })}
      >
        {/* 具体的sku每一项 */}
        {data.values.slice(0, getLimitNumber()).map((i, index) => (
          <Item
            attrIndex={index}
            {...props}
            isLast={isLast}
            skuId={data.id}
            item={i}
            type={type}
            availableActivity={availableActivity}
          />
        ))}
        {renderSkuMore()}
        {showType === 'sku' && data.values.length > 7 && (
          <span
            className="more"
            onClick={() => {
              doLog('/sc.details.skuArea', `second=${secondScreen}&from=sku`, 'EXP');
              dialogShow({
                type,
              });
            }}
          >
            +{data.values.length - 7}
          </span>
        )}
      </div>
    </>
  );
}
